module.exports = __webpack_public_path__ + "static/assets/d6f7dab02cab1c0bb35a8ea7e1a7320e.png";